import { pgTable } from 'drizzle-orm/pg-core'
import { createInsertSchema, createSelectSchema } from 'drizzle-zod'
import { relations } from 'drizzle-orm'
import { z } from 'zod'
import { Contracts } from './contracts'
import { Transactions } from './transactions'
import { generateId } from './utils'
import { ContractTypeEnum } from './enums'

// Table
export const TransactionContracts = pgTable('Transaction_contracts', (t) => ({
//   id: t.text().primaryKey().$defaultFn(() => generateId(12)),

  contractId: t.text('contract_id'),
  transactionId: t.text('transaction_id'),
  vendorId: t.text('vendor_id'),
  uniqueTransactionId: t.text('unique_transaction_id'),
  recurringVendorId: t.text('recurring_vendor_id'), // nullable
  type: ContractTypeEnum().notNull().default('contract'),
  vendorName: t.text('vendor_name'),   // nullable
  totalAmount: t.real('total_amount'), // nullable
  transactionDate: t.text('transaction_date'), // varchar, nullable
  organizationId: t.text('organization_id'), // nullable
  lineId: t.text('line_id'),
  detailType: t.text('detail_type'),
  description: t.text('description'),
  subCategory: t.text('sub_category'),
  accountValue: t.text('account_value'),
  taxCode: t.text('tax_code'),
  billableStatus: t.text('billable_status'),
  source: t.text('source'),
  category: t.text('category'),
  currency: t.text('currency')
}))

// Types
export type TransactionContract = typeof TransactionContracts.$inferSelect
export type TransactionContractInsert = typeof TransactionContracts.$inferInsert

// Zod Schemas
export const insertTransactionContractSchema = createInsertSchema(TransactionContracts)
export const selectTransactionContractSchema = createSelectSchema(TransactionContracts)

// Relations
export const transactionContractRelations = relations(TransactionContracts, ({ one }) => ({
  contract: one(Contracts, {
    fields: [TransactionContracts.contractId],
    references: [Contracts.id],
  }),
  transaction: one(Transactions, {
    fields: [TransactionContracts.transactionId],
    references: [Transactions.transactionId],
  }),
}))
